import { InitialsField } from '../../types';
import { CheckoutSection } from './CheckoutSection';

interface InitialsAcknowledgmentSectionProps {
  field: InitialsField;
  checkoutMessage?: string | null;
  value: string;
  onChange: (value: string) => void;
}

export function InitialsAcknowledgmentSection({
  field,
  checkoutMessage,
  value,
  onChange,
}: InitialsAcknowledgmentSectionProps) {
  return (
    <CheckoutSection title={field.label}>
      {checkoutMessage && (
        <div
          className="mb-4 text-sm text-gray-700 prose prose-sm max-w-none"
          dangerouslySetInnerHTML={{ __html: checkoutMessage }}
        />
      )}
      <div className="flex flex-col gap-1 max-w-xs">
        <label htmlFor={`cf_${field.name}`} className="block text-sm font-medium text-gray-700">
          Enter your initials to acknowledge
          {field.required && <span className="text-red-500 ml-1" aria-hidden="true">*</span>}
        </label>
        <input
          type="text"
          id={`cf_${field.name}`}
          value={value}
          onChange={(e) => onChange(e.target.value.toUpperCase())}
          required={field.required}
          maxLength={field.charLimit ?? 10}
          placeholder="e.g. JD"
          className="w-32 border border-gray-300 rounded-lg px-3 py-2 text-sm font-mono uppercase tracking-widest focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
        />
      </div>
    </CheckoutSection>
  );
}
